import { useQuery } from '@tanstack/react-query';
import { CircularProgress } from 'src/components/CircularProgress';
import { fetchSellables } from 'src/models/payment/payment';
import { SellableSelect } from 'src/shared/Forms/Selects/SellableSelect';
import { Identifier } from 'src/types/utilityTypes';

interface ItemFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
  multiple?: boolean;
  type?: string;
}

export const ItemFilter: React.FC<ItemFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
  multiple = true,
  type,
}) => {
  const { data: sellables, isLoading } = useQuery({
    queryKey: ['sellables'],

    queryFn: () => fetchSellables(type),
  });

  if (isLoading) {
    return <CircularProgress />;
  }

  const itemIds = value ? String(value).split(',') : [];
  const selectedItems = sellables?.filter((s) =>
    itemIds.includes(`${s.id} ${s.type}`)
  );

  if (valueOnly) {
    return <>{selectedItems?.map((s) => s.name)?.join(', ') || ''}</>;
  }

  return (
    <SellableSelect
      label={label}
      value={
        multiple
          ? ((selectedItems?.map((s) => `${s.id} ${s.type}`) ||
              []) as Identifier[])
          : ((selectedItems?.[0]
              ? `${selectedItems[0].id} ${selectedItems[0].type}`
              : '') as Identifier)
      }
      onChange={(newValue) => {
        if (multiple) {
          setValue(
            (Array.isArray(newValue) ? newValue : [])
              .map((s) => `${s.value?.id} ${s.value?.type}`)
              .join(',')
          );
        } else {
          if (!newValue) {
            setValue('');
          } else {
            setValue(`${newValue?.value?.id} ${newValue?.value?.type}`);
          }
        }
      }}
      type={type}
      multiple={multiple}
    />
  );
};
